import React from 'react';
import PortalManage from './PortalManage';

// V3 reskin: the page renders its own glass hero, so the legacy
// Breadcrumbs strip + Bootstrap Container wrapper are dropped.
const TenantPortal = () => <PortalManage />;

export default TenantPortal;
